import { getMarketInfo } from '@/api/appStore';
import {
  deleteStoreAppManage,
  fetchStoreAppManageList,
  fetchStoreCustomersList,
  fetchStoreDeliveryAppInfo,
  fetchStoreInfo,
  fetchStoreList,
  fetchStoreOrderInfo,
  fetchStoreOrderList,
  fetchStoreToDelivery,
  registerStores,
  upDateStores,
  upDateStoresInfo,
  upOrderAudit,
  upOrderDelivery
} from '@/api/stores';
const stores = {
  state: {
    marketInfo: {}
  },

  mutations: {
    SET_MARKET_INFO: (state, marketInfo) => {
      state.marketInfo = marketInfo;
    }
  },

  actions: {
    GetMarketDetail({ commit }, playload) {
      return new Promise((resolve, reject) => {
        getMarketInfo(playload)
          .then((response) => {
            commit('SET_MARKET_INFO', response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取商家订单管理数据
    GetStoreOrderList(_, resdata) {
      return new Promise((resolve, reject) => {
        fetchStoreOrderList(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取商家订单管理数据
    GetStoreOrderInfo(_, resdata) {
      return new Promise((resolve, reject) => {
        fetchStoreOrderInfo(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取商家交付应用详情
    GetStoreDeliveryAppInfo(_, resdata) {
      return new Promise((resolve, reject) => {
        fetchStoreDeliveryAppInfo(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取商家重新交付
    PutStoreToDelivery(_, resdata) {
      return new Promise((resolve, reject) => {
        fetchStoreToDelivery(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取商家订单发货
    PutOrderDelivery(_, resdata) {
      return new Promise((resolve, reject) => {
        upOrderDelivery(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取商家订单 审核
    PutOrderAudit(_, resdata) {
      return new Promise((resolve, reject) => {
        upOrderAudit(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 开通商店
    UpDateStores({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        upDateStores(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 注册商店
    RegisterStores(_, resdata) {
      return new Promise((resolve, reject) => {
        registerStores(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取商店信息
    GetStoresInfo(_, resdata) {
      return new Promise((resolve, reject) => {
        fetchStoreInfo(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 修改商店信息
    UpDateStoresInfo(_, resdata) {
      return new Promise((resolve, reject) => {
        upDateStoresInfo(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取商店列表
    GetStoreList(_, resdata) {
      return new Promise((resolve, reject) => {
        fetchStoreList(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取商店客户列表
    GetStoreCustomersList(_, resdata) {
      return new Promise((resolve, reject) => {
        fetchStoreCustomersList(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取商店应用管理列表
    GetStoreAppManageList(_, resdata) {
      return new Promise((resolve, reject) => {
        fetchStoreAppManageList(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 删除商店应用管理应用
    DeleteStoreAppManage(_, resdata) {
      return new Promise((resolve, reject) => {
        deleteStoreAppManage(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  }
};

export default stores;



// WEBPACK FOOTER //
// ./src/store/modules/stores.js